<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <Header/>
      <b-container fluid>
  
        <b-row class="titulo">
          <b-col class="seccionTitulo">
            <span class="fa fa-table"></span>
            <span>Empresa tipo</span>
          </b-col>
          <b-col class="seccionCodigo">
            <div>Tipo_empresa</div>
          </b-col>
        </b-row>
  
        <b-row>
          <b-col class="subtitulos">
            Búsqueda de empresa tipo
          </b-col>
        </b-row>
  
        <b-row>
          <b-col>
            <b-row align-v="center" align-h="end">
              <b-col>
  
                <b-form-group align="left">
                  <label for="nombreBusq">Palabra clave</label>
                  <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input name="nombre" placeholder="Nombre de la empresa tipo"
                                  v-model="filtro.palabraClave" @keydown.enter.native="obtenerEmpresaTipo"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
  
              </b-col>
  
              <b-col></b-col>
  
              <b-col align="right" >
                <b-button v-b-tooltip.hover title="Crear Empresa tipo" variant="outline-success"
                          @click="agregar()" v-if="$localStorageService.can('Empresa_tipo_crear')">Crear Empresa tipo
                </b-button>
              </b-col>
  
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-table
                id="Pendientes"
                thead-tr-class="columnas"
                :items="datosTabla"
                :fields="fields"
                :per-page="registrosPorPagina"
                :current-page="paginaActual"
                responsive="true"
                class="parrafos"
                fixed>
                <template v-slot:cell(fechaModificacion)="row">
                                  {{ row.item.fechaModificacion | formatoFechaCorta }}
                              </template>
              <template v-slot:cell(Acciones)="row">
                <b-button-group>
                  <b-button
                      v-if="$localStorageService.can('Empresa_tipo_editar')"
                      title="Modificar plan"
                      size="sm"
                      @click="modificar(row.item)"
                      variant="outline-warning"
                  ><em class="fa fa-pencil"></em></b-button>
                  <b-button v-if="!row.item.registroActivo && $localStorageService.can('Empresa_tipo_activar')"
                            title="Activar Empresa tipo"
                            variant="outline-danger"
                            size="sm"
                            @click="activar(row.item)"
                  ><em class="fa fa-undo"></em></b-button>
                  <b-button v-else
                            title="Desactivar Empresa tipo"
                            variant="outline-danger"
                            size="sm"
                            @click="desactivar(row.item)"
                  >
                    <b-icon icon="trash-fill"></b-icon>
                  </b-button>
                </b-button-group>
  
              </template>
            </b-table>
            <div align="center" v-if="loader">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </div>
            <b-col v-if="!loader">
              <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
            </b-col>
            <b-col v-if="!loader">
              <b-pagination
                  v-if="datosTabla !== undefined && datosTabla.length > 10"
                  align="center"
                  v-model="paginaActual"
                  :total-rows="datosTabla.length"
                  :per-page="registrosPorPagina"
                  aria-controls="my-table1"
              ></b-pagination>
            </b-col>
          </b-col>
  
  
        </b-row>
  
      </b-container>
  
  
      <b-modal
          v-model="show"
          :title="tituloModal"
          size="lg"
      >
        <b-container fluid>
          <b-row>
            <b-col>
              <b-form>
                <b-form-group align="left">
                  <label for="nombreTipo">Nombre
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="nombreTipo" name="nombreTipo" placeholder="Nombre de la empresa tipo"
                                  v-model="$v.EmpresaTipo.nombreTipo.$model"
                                  :state="validateState('nombreTipo')"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <b-form-group align="left">
                  <label for="orden">Orden
                    <validacion/>
                  </label>
                  <b-input-group size="sm" class="mb-2">
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input id="orden" name="orden" placeholder="Orden de la empresa tipo"
                                  v-model="$v.EmpresaTipo.orden.$model"
                                  :state="validateState('orden')"
                                  type="number"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-form>
            </b-col>
          </b-row>
        </b-container>
        <div slot="modal-footer">
          <b-button variant="outline-primary" :disabled="loaderAcciones" @click="guardar()">
            <span v-if="!loaderAcciones">Guardar</span>
            <span v-if="loaderAcciones">
                          <b-spinner small></b-spinner>
                      Cargando...
                      </span>
          </b-button>
          <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
        </div>
      </b-modal>
    </div>
</template>
  
<script>
    import Header from "@/components/Header";
    import {validationMixin} from "vuelidate";
    import {required} from "vuelidate/lib/validators";


    export default {
    name: "EmpresaTipo",
    components: {
        Header
    },
    mixins: [validationMixin],
    data: () => {
        return {
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,

        datosTabla: [],
        fields: [
            {key: "idEmpresaTipo", label: "ID", sortable: true},
            {key: "nombreTipo", label: "Nombre", sortable: true},
            {key: "orden", label: "Orden", sortable: true},
            {key: "fechaModificacion", label: "Fecha modificación", sortable: true},
            {key: "nombreUsuarioModificacion", label: "Usuario modificación", sortable: true},
            "Acciones",
        ],
        registrosPorPagina: 15,
        paginaActual: 0,
        show: false,
        showDetalle: false,
        tituloModal: '',
        EmpresaTipo: {
            idEmpresaTipo: null,
            nombreTipo: null,
            orden: null,
            registroActivo: null,
        },
        loaderAcciones: false,
        loader: false,
        filtro: {
            id: null,
            palabraClave: null,
            registroActivo: null
        },
        }
    },
    validations: {
        EmpresaTipo: {
            nombreTipo: {required},
            orden: {required},
        }
    },
    created() {
      this.debug = this.$localStorageService.getDebug();

      this.obtenerEmpresaTipo();
    },
    methods: {
        obtenerEmpresaTipo() {
            this.loader = true
            this.datosTabla = [];
            this.$http.post(this.$api + 'empresas/obtener/empresaTipo', this.filtro).then(respuesta => {
                    if (respuesta.data.data) {
                    this.datosTabla = respuesta.data.data
                    }
                }
            ).finally(() => {
                    this.loader = false;
                }
            )
            },
        agregar() {
            this.EmpresaTipo = {
                idEmpresaTipo: null,
                nombreTipo: null,
                orden: null,
            };
            this.tituloModal = 'Agregar empresa tipo';
            this.show = true;
        },
        guardar() {
            this.$v.EmpresaTipo.$touch();
            if (this.$v.EmpresaTipo.$anyError) {
                return;
            }
            if (!this.$v.EmpresaTipo.$invalid) {
                this.loaderAcciones = true;
                this.$http.post(this.$api + 'empresas/guardar/empresaTipo', this.EmpresaTipo).then(respuesta => {
                    if (respuesta.data.data) {
                        this.obtenerEmpresaTipo();
                        this.show = false;
                        this.$swal.fire({
                        icon: "info",
                        title: "Aviso",
                        text: "La empresa tipo se guardó correctamente",
                        });
                    }
                    }
                ).finally(() => {
                    this.loaderAcciones = false;
                    }
                )
            }
        },
        modificar(item) {
            this.EmpresaTipo = item;
            this.tituloModal = 'Modificar empresa tipo';
            this.show = true;
        },

        activar(item) {
        this.$swal({
            icon: "error",
            text: "¿Está seguro de activar la empresa tipo?",
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            showCancelButton: true,
            showConfirmButton: true,
        }).then((aceptar) => {
            if(aceptar.value){
              const parametros = {
                idEmpresaTipo: item.idEmpresaTipo,
              }
                this.$http.post(this.$api + 'empresas/activar/empresaTipo', parametros).then(respuesta => {
                    if(respuesta.data.data){
                        this.datosTabla[this.datosTabla.indexOf(item)].registroActivo = true;
                    }
                })
            }
        })
      },
      desactivar(item){
        this.$swal({
            icon: "warning",
            text: "¿Está seguro de desactivar la empresa tipo?",
            confirmButtonText: 'Si',
            cancelButtonText: 'No',
            showCancelButton: true,
            showConfirmButton: true,
        }).then((aceptar) => {
            if(aceptar.value){
              const parametros = {
                idEmpresaTipo: item.idEmpresaTipo,
              }
                this.$http.post(this.$api + 'empresas/desactivar/empresaTipo', parametros).then(respuesta => {
                    if(respuesta.data.data){
                        this.datosTabla[this.datosTabla.indexOf(item)].registroActivo = false;
                    }
                })
            }
        })
      },
        validateState(name) {
            const {$dirty, $error} = this.$v.EmpresaTipo[name];
            return $dirty ? !$error : null;
        },
        cerrarModal() {
            this.showDetalle = false;
            this.show = false;
        }
    }
    }
</script>

<style scoped>

</style>